import customAxios from "./axiosConfig";

const VATBelgianReportService = {
    get: function (id, params) {
        var api_url = window.Urls['belgiumvatreport_detail'](id);
        return customAxios.get(api_url, { params: params });
    },
    list: function (params) {
        var api_url = window.Urls['belgiumvatreport_list']();
        return customAxios.get(api_url, { params: params });
    },
    update: function (id, data) {
        var api_url = window.Urls['belgiumvatreport-detail'](id);
        return customAxios.patch(api_url, data);
    },
    create: function (data) {
        var api_url = window.Urls['belgiumvatreport-list']();
        return customAxios.post(api_url, data);
    },
    count: function (params) {
        var api_url = window.Urls['belgiumvatreport_count']();
        return customAxios.get(api_url, { params: params });
    },
    destroy: function (id) {
        var api_url = window.Urls['belgiumvatreport-detail'](id);
        return customAxios.delete(api_url);
    },
    recalculate: function (id, params) {
        var api_url = window.Urls['belgiumvatreport_recalculate'](id);
        return customAxios.get(api_url, {params: params});
    },
    getPDFBlob (id) {
        const api_url = window.Urls['belgiumvatreport_download_pdf'](id)
        return customAxios.get(api_url, { responseType: 'blob' }).then((response) => {
            return response
        })
    },
};

export default VATBelgianReportService;